import { render } from "./ProfilePanel.vue?vue&type=template&id=a6b49ab8&scoped=true&ts=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=ts"
export * from "./ProfilePanel.vue?vue&type=script&lang=ts"

import "./ProfilePanel.vue?vue&type=style&index=0&id=a6b49ab8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b49ab8"]])

export default __exports__